import { Pannel, Province } from "types/canvasTypes";

export const glassList36H: Pannel[] = [
  {
    length: 7.9,
    bcVariantId: "gid://shopify/ProductVariant/55237139169649",
    grVariantId: "gid://shopify/ProductVariant/44316441772217",
    rfVariantId: "gid://shopify/ProductVariant/46272741179556",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 55],
    ]),
  },
  {
    length: 8.9,
    bcVariantId: "gid://shopify/ProductVariant/55237139202417",
    grVariantId: "gid://shopify/ProductVariant/44316441804985",
    rfVariantId: "gid://shopify/ProductVariant/46272741212324",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 56],
    ]),
  },
  {
    length: 9.8,
    bcVariantId: "gid://shopify/ProductVariant/55237139235185",
    grVariantId: "gid://shopify/ProductVariant/44316441837753",
    rfVariantId: "gid://shopify/ProductVariant/46272741245092",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 57],
    ]),
  },
  {
    length: 10.9,
    bcVariantId: "gid://shopify/ProductVariant/55237139267953",
    grVariantId: "gid://shopify/ProductVariant/44316441870521",
    rfVariantId: "gid://shopify/ProductVariant/46272741277860",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 60],
    ]),
  },
  {
    length: 11.8,
    bcVariantId: "gid://shopify/ProductVariant/55237139300721",
    grVariantId: "gid://shopify/ProductVariant/44316441903289",
    rfVariantId: "gid://shopify/ProductVariant/46272741310628",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 63],
    ]),
  },
  {
    length: 13.8,
    bcVariantId: "gid://shopify/ProductVariant/55237139333489",
    grVariantId: "gid://shopify/ProductVariant/44316441936057",
    rfVariantId: "gid://shopify/ProductVariant/46272741343396",
    price: new Map([
      [Province.Quebec, 36],
      [Province.Ontario, 66],
    ]),
  },
  {
    length: 15.7,
    bcVariantId: "gid://shopify/ProductVariant/55237139366257",
    grVariantId: "gid://shopify/ProductVariant/44316441968825",
    rfVariantId: "gid://shopify/ProductVariant/46272741376164",
    price: new Map([
      [Province.Quebec, 37],
      [Province.Ontario, 69],
    ]),
  },
  {
    length: 17.7,
    bcVariantId: "gid://shopify/ProductVariant/55237139399025",
    grVariantId: "gid://shopify/ProductVariant/44316442001593",
    rfVariantId: "gid://shopify/ProductVariant/46272741408932",
    price: new Map([
      [Province.Quebec, 44],
      [Province.Ontario, 72],
    ]),
  },
  {
    length: 19.7,
    bcVariantId: "gid://shopify/ProductVariant/55237139431793",
    grVariantId: "gid://shopify/ProductVariant/44316442034361",
    rfVariantId: "gid://shopify/ProductVariant/46272741441700",
    price: new Map([
      [Province.Quebec, 45],
      [Province.Ontario, 77],
    ]),
  },
  {
    length: 21.7,
    bcVariantId: "gid://shopify/ProductVariant/55237139464561",
    grVariantId: "gid://shopify/ProductVariant/44316442067129",
    rfVariantId: "gid://shopify/ProductVariant/46272741474468",
    price: new Map([
      [Province.Quebec, 46],
      [Province.Ontario, 80],
    ]),
  },
  {
    length: 23.6,
    bcVariantId: "gid://shopify/ProductVariant/55237139497329",
    grVariantId: "gid://shopify/ProductVariant/44316442099897",
    rfVariantId: "gid://shopify/ProductVariant/46272741507236",
    price: new Map([
      [Province.Quebec, 47],
      [Province.Ontario, 85],
    ]),
  },
  {
    length: 25.6,
    bcVariantId: "gid://shopify/ProductVariant/55237139530097",
    grVariantId: "gid://shopify/ProductVariant/44316442132665",
    rfVariantId: "gid://shopify/ProductVariant/46272741540004",
    price: new Map([
      [Province.Quebec, 55],
      [Province.Ontario, 90],
    ]),
  },
  {
    length: 27.6,
    bcVariantId: "gid://shopify/ProductVariant/55237139562865",
    grVariantId: "gid://shopify/ProductVariant/44316442165433",
    rfVariantId: "gid://shopify/ProductVariant/46272741572772",
    price: new Map([
      [Province.Quebec, 56],
      [Province.Ontario, 95],
    ]),
  },
  {
    length: 29.5,
    bcVariantId: "gid://shopify/ProductVariant/55237139595633",
    grVariantId: "gid://shopify/ProductVariant/44316442198201",
    rfVariantId: "gid://shopify/ProductVariant/46272741605540",
    price: new Map([
      [Province.Quebec, 57],
      [Province.Ontario, 100],
    ]),
  },
  {
    length: 31.5,
    bcVariantId: "gid://shopify/ProductVariant/55237139628401",
    grVariantId: "gid://shopify/ProductVariant/44316442230969",
    rfVariantId: "gid://shopify/ProductVariant/46272741638308",
    price: new Map([
      [Province.Quebec, 67],
      [Province.Ontario, 105],
    ]),
  },
  {
    length: 33.5,
    bcVariantId: "gid://shopify/ProductVariant/55237139661169",
    grVariantId: "gid://shopify/ProductVariant/44316442263737",
    rfVariantId: "gid://shopify/ProductVariant/46272741671076",
    price: new Map([
      [Province.Quebec, 75],
      [Province.Ontario, 110],
    ]),
  },
  {
    length: 35.4,
    bcVariantId: "gid://shopify/ProductVariant/55237139693937",
    grVariantId: "gid://shopify/ProductVariant/44316442296505",
    rfVariantId: "gid://shopify/ProductVariant/46272741703844",
    price: new Map([
      [Province.Quebec, 76],
      [Province.Ontario, 115],
    ]),
  },
  {
    length: 37.4,
    bcVariantId: "gid://shopify/ProductVariant/55237139726705",
    grVariantId: "gid://shopify/ProductVariant/44316442329273",
    rfVariantId: "gid://shopify/ProductVariant/46272741736612",
    price: new Map([
      [Province.Quebec, 77],
      [Province.Ontario, 120],
    ]),
  },
  {
    length: 39.4,
    bcVariantId: "gid://shopify/ProductVariant/55237139759473",
    grVariantId: "gid://shopify/ProductVariant/44316442362041",
    rfVariantId: "gid://shopify/ProductVariant/46272741769380",
    price: new Map([
      [Province.Quebec, 95],
      [Province.Ontario, 125],
    ]),
  },
  {
    length: 41.3,
    bcVariantId: "gid://shopify/ProductVariant/55237139792241",
    grVariantId: "gid://shopify/ProductVariant/44316442394809",
    rfVariantId: "gid://shopify/ProductVariant/46272741802148",
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 127],
    ]),
  },
  {
    length: 43.3,
    bcVariantId: "gid://shopify/ProductVariant/55237139825009",
    grVariantId: "gid://shopify/ProductVariant/44316442427577",
    rfVariantId: "gid://shopify/ProductVariant/46272741834916",
    price: new Map([
      [Province.Quebec, 97],
      [Province.Ontario, 130],
    ]),
  },
  {
    length: 45.3,
    bcVariantId: "gid://shopify/ProductVariant/55237139857777",
    grVariantId: "gid://shopify/ProductVariant/44316442460345",
    rfVariantId: "gid://shopify/ProductVariant/46272741867684",
    price: new Map([
      [Province.Quebec, 98],
      [Province.Ontario, 134],
    ]),
  },
  {
    length: 47.2,
    bcVariantId: "gid://shopify/ProductVariant/55237139890545",
    grVariantId: "gid://shopify/ProductVariant/44316442493113",
    rfVariantId: "gid://shopify/ProductVariant/46272741900452",
    price: new Map([
      [Province.Quebec, 101],
      [Province.Ontario, 138],
    ]),
  },
  {
    length: 49.2,
    bcVariantId: "gid://shopify/ProductVariant/55237139923313",
    grVariantId: "gid://shopify/ProductVariant/44316442525881",
    rfVariantId: "gid://shopify/ProductVariant/46272741933220",
    price: new Map([
      [Province.Quebec, 106],
      [Province.Ontario, 142],
    ]),
  },
  {
    length: 51.2,
    bcVariantId: "gid://shopify/ProductVariant/55237139956081",
    grVariantId: "gid://shopify/ProductVariant/44316442558649",
    rfVariantId: "gid://shopify/ProductVariant/46272741965988",
    price: new Map([
      [Province.Quebec, 108],
      [Province.Ontario, 145],
    ]),
  },
  {
    length: 53.1,
    bcVariantId: "gid://shopify/ProductVariant/55237139988849",
    grVariantId: "gid://shopify/ProductVariant/44316442591417",
    rfVariantId: "gid://shopify/ProductVariant/46272741998756",
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 147],
    ]),
  },
  {
    length: 55.1,
    bcVariantId: "gid://shopify/ProductVariant/55237140021617",
    grVariantId: "gid://shopify/ProductVariant/44316442624185",
    rfVariantId: "gid://shopify/ProductVariant/46272742031524",
    price: new Map([
      [Province.Quebec, 116],
      [Province.Ontario, 150],
    ]),
  },
  {
    length: 57.7,
    bcVariantId: "gid://shopify/ProductVariant/55237140054385",
    grVariantId: "gid://shopify/ProductVariant/44316442656953",
    rfVariantId: "gid://shopify/ProductVariant/46272742064292",
    price: new Map([
      [Province.Quebec, 119],
      [Province.Ontario, 153],
    ]),
  },
  {
    length: 59.1,
    bcVariantId: "gid://shopify/ProductVariant/55237140087153",
    grVariantId: "gid://shopify/ProductVariant/44316442689721",
    rfVariantId: "gid://shopify/ProductVariant/46272742097060",
    price: new Map([
      [Province.Quebec, 126],
      [Province.Ontario, 157],
    ]),
  },
  {
    length: 61,
    bcVariantId: "gid://shopify/ProductVariant/55237140119921",
    grVariantId: "gid://shopify/ProductVariant/44316442722489",
    rfVariantId: "gid://shopify/ProductVariant/46272742129828",
    price: new Map([
      [Province.Quebec, 129],
      [Province.Ontario, 160],
    ]),
  },
  {
    length: 63,
    bcVariantId: "gid://shopify/ProductVariant/55237140152689",
    grVariantId: "gid://shopify/ProductVariant/44316442755257",
    rfVariantId: "gid://shopify/ProductVariant/46272742162596",
    price: new Map([
      [Province.Quebec, 139],
      [Province.Ontario, 200],
    ]),
  },
  {
    length: 65,
    bcVariantId: "gid://shopify/ProductVariant/55237140185457",
    grVariantId: "gid://shopify/ProductVariant/44316442788025",
    rfVariantId: "gid://shopify/ProductVariant/46272742195364",
    price: new Map([
      [Province.Quebec, 146],
      [Province.Ontario, 210],
    ]),
  },
  {
    length: 66.9,
    bcVariantId: "gid://shopify/ProductVariant/55237140218225",
    grVariantId: "gid://shopify/ProductVariant/44316442820793",
    rfVariantId: "gid://shopify/ProductVariant/46272742228132",
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 220],
    ]),
  },
  {
    length: 68.9,
    bcVariantId: "gid://shopify/ProductVariant/55237140250993",
    grVariantId: "gid://shopify/ProductVariant/44316442853561",
    rfVariantId: "gid://shopify/ProductVariant/46272742260900",
    price: new Map([
      [Province.Quebec, 156],
      [Province.Ontario, 235],
    ]),
  },
  {
    length: 70.9,
    bcVariantId: "gid://shopify/ProductVariant/55237140283761",
    grVariantId: "gid://shopify/ProductVariant/44316442886329",
    rfVariantId: "gid://shopify/ProductVariant/46272742293668",
    price: new Map([
      [Province.Quebec, 158],
      [Province.Ontario, 250],
    ]),
  },
  {
    length: 72.8,
    bcVariantId: "gid://shopify/ProductVariant/55237140316529",
    grVariantId: "gid://shopify/ProductVariant/44316442919097",
    rfVariantId: "gid://shopify/ProductVariant/46272742326436",
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 260],
    ]),
  },
];

export const glassList42H: Pannel[] = [
  {
    length: 7.9,
    bcVariantId: "gid://shopify/ProductVariant/55237140775281",
    grVariantId: "gid://shopify/ProductVariant/44316443312313",
    rfVariantId: "gid://shopify/ProductVariant/46272743309476",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 65],
    ]),
  },
  {
    length: 8.9,
    bcVariantId: "gid://shopify/ProductVariant/55237140808049",
    grVariantId: "gid://shopify/ProductVariant/44316443345081",
    rfVariantId: "gid://shopify/ProductVariant/46272743342244",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 66],
    ]),
  },
  {
    length: 9.8,
    bcVariantId: "gid://shopify/ProductVariant/55237140840817",
    grVariantId: "gid://shopify/ProductVariant/44316443377849",
    rfVariantId: "gid://shopify/ProductVariant/46272743407780",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 67],
    ]),
  },
  {
    length: 10.9,
    bcVariantId: "gid://shopify/ProductVariant/55237140873585",
    grVariantId: "gid://shopify/ProductVariant/44316443410617",
    rfVariantId: "gid://shopify/ProductVariant/46272743440548",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 70],
    ]),
  },
  {
    length: 11.8,
    bcVariantId: "gid://shopify/ProductVariant/55237140906353",
    grVariantId: "gid://shopify/ProductVariant/44316443443385",
    rfVariantId: "gid://shopify/ProductVariant/46272743473316",
    price: new Map([
      [Province.Quebec, 36],
      [Province.Ontario, 75],
    ]),
  },
  {
    length: 13.8,
    bcVariantId: "gid://shopify/ProductVariant/55237140939121",
    grVariantId: "gid://shopify/ProductVariant/44316443476153",
    rfVariantId: "gid://shopify/ProductVariant/46272743506084",
    price: new Map([
      [Province.Quebec, 37],
      [Province.Ontario, 80],
    ]),
  },
  {
    length: 15.7,
    bcVariantId: "gid://shopify/ProductVariant/55237140971889",
    grVariantId: "gid://shopify/ProductVariant/44316443508921",
    rfVariantId: "gid://shopify/ProductVariant/46272743538852",
    price: new Map([
      [Province.Quebec, 38],
      [Province.Ontario, 85],
    ]),
  },
  {
    length: 17.7,
    bcVariantId: "gid://shopify/ProductVariant/55237141004657",
    grVariantId: "gid://shopify/ProductVariant/44316443541689",
    rfVariantId: "gid://shopify/ProductVariant/46272743571620",
    price: new Map([
      [Province.Quebec, 48],
      [Province.Ontario, 90],
    ]),
  },
  {
    length: 19.7,
    bcVariantId: "gid://shopify/ProductVariant/55237141037425",
    grVariantId: "gid://shopify/ProductVariant/44316443574457",
    rfVariantId: "gid://shopify/ProductVariant/46272743604388",
    price: new Map([
      [Province.Quebec, 49],
      [Province.Ontario, 93],
    ]),
  },
  {
    length: 21.7,
    bcVariantId: "gid://shopify/ProductVariant/55237141070193",
    grVariantId: "gid://shopify/ProductVariant/44316443607225",
    rfVariantId: "gid://shopify/ProductVariant/46272743637156",
    price: new Map([
      [Province.Quebec, 57],
      [Province.Ontario, 96],
    ]),
  },
  {
    length: 23.6,
    bcVariantId: "gid://shopify/ProductVariant/55237141102961",
    grVariantId: "gid://shopify/ProductVariant/44316443639993",
    rfVariantId: "gid://shopify/ProductVariant/46272743669924",
    price: new Map([
      [Province.Quebec, 58],
      [Province.Ontario, 100],
    ]),
  },
  {
    length: 25.6,
    bcVariantId: "gid://shopify/ProductVariant/55237141135729",
    grVariantId: "gid://shopify/ProductVariant/44316443672761",
    rfVariantId: "gid://shopify/ProductVariant/46272743702692",
    price: new Map([
      [Province.Quebec, 69],
      [Province.Ontario, 105],
    ]),
  },
  {
    length: 27.6,
    bcVariantId: "gid://shopify/ProductVariant/55237141168497",
    grVariantId: "gid://shopify/ProductVariant/44316443705529",
    rfVariantId: "gid://shopify/ProductVariant/46272743735460",
    price: new Map([
      [Province.Quebec, 74],
      [Province.Ontario, 110],
    ]),
  },
  {
    length: 29.5,
    bcVariantId: "gid://shopify/ProductVariant/55237141201265",
    grVariantId: "gid://shopify/ProductVariant/44316443738297",
    rfVariantId: "gid://shopify/ProductVariant/46272743768228",
    price: new Map([
      [Province.Quebec, 76],
      [Province.Ontario, 112],
    ]),
  },
  {
    length: 31.5,
    bcVariantId: "gid://shopify/ProductVariant/55237141234033",
    grVariantId: "gid://shopify/ProductVariant/44316443771065",
    rfVariantId: "gid://shopify/ProductVariant/46272743800996",
    price: new Map([
      [Province.Quebec, 79],
      [Province.Ontario, 115],
    ]),
  },
  {
    length: 33.5,
    bcVariantId: "gid://shopify/ProductVariant/55237141266801",
    grVariantId: "gid://shopify/ProductVariant/44316443803833",
    rfVariantId: "gid://shopify/ProductVariant/46272743833764",
    price: new Map([
      [Province.Quebec, 84],
      [Province.Ontario, 120],
    ]),
  },
  {
    length: 35.4,
    bcVariantId: "gid://shopify/ProductVariant/55237141299569",
    grVariantId: "gid://shopify/ProductVariant/44316443836601",
    rfVariantId: "gid://shopify/ProductVariant/46272743866532",
    price: new Map([
      [Province.Quebec, 86],
      [Province.Ontario, 130],
    ]),
  },
  {
    length: 37.4,
    bcVariantId: "gid://shopify/ProductVariant/55237141332337",
    grVariantId: "gid://shopify/ProductVariant/44316443869369",
    rfVariantId: "gid://shopify/ProductVariant/46272743899300",
    price: new Map([
      [Province.Quebec, 89],
      [Province.Ontario, 135],
    ]),
  },
  {
    length: 39.4,
    bcVariantId: "gid://shopify/ProductVariant/55237141365105",
    grVariantId: "gid://shopify/ProductVariant/44316443902137",
    rfVariantId: "gid://shopify/ProductVariant/46272743932068",
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 140],
    ]),
  },
  {
    length: 41.3,
    bcVariantId: "gid://shopify/ProductVariant/55237141397873",
    grVariantId: "gid://shopify/ProductVariant/44316443934905",
    rfVariantId: "gid://shopify/ProductVariant/46272743964836",
    price: new Map([
      [Province.Quebec, 99],
      [Province.Ontario, 145],
    ]),
  },
  {
    length: 43.3,
    bcVariantId: "gid://shopify/ProductVariant/55237141430641",
    grVariantId: "gid://shopify/ProductVariant/44316443967673",
    rfVariantId: "gid://shopify/ProductVariant/46272743997604",
    price: new Map([
      [Province.Quebec, 106],
      [Province.Ontario, 148],
    ]),
  },
  {
    length: 45.3,
    bcVariantId: "gid://shopify/ProductVariant/55237141463409",
    grVariantId: "gid://shopify/ProductVariant/44316444000441",
    rfVariantId: "gid://shopify/ProductVariant/46272744030372",
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 152],
    ]),
  },
  {
    length: 47.2,
    bcVariantId: "gid://shopify/ProductVariant/55237141496177",
    grVariantId: "gid://shopify/ProductVariant/44316444033209",
    rfVariantId: "gid://shopify/ProductVariant/46272744063140",
    price: new Map([
      [Province.Quebec, 116],
      [Province.Ontario, 155],
    ]),
  },
  {
    length: 49.2,
    bcVariantId: "gid://shopify/ProductVariant/55237141528945",
    grVariantId: "gid://shopify/ProductVariant/44316444065977",
    rfVariantId: "gid://shopify/ProductVariant/46272744095908",
    price: new Map([
      [Province.Quebec, 119],
      [Province.Ontario, 157],
    ]),
  },
  {
    length: 51.2,
    bcVariantId: "gid://shopify/ProductVariant/55237141561713",
    grVariantId: "gid://shopify/ProductVariant/44316444098745",
    rfVariantId: "gid://shopify/ProductVariant/46272744128676",
    price: new Map([
      [Province.Quebec, 126],
      [Province.Ontario, 160],
    ]),
  },
  {
    length: 53.1,
    bcVariantId: "gid://shopify/ProductVariant/55237141594481",
    grVariantId: "gid://shopify/ProductVariant/44316444131513",
    rfVariantId: "gid://shopify/ProductVariant/46272744161444",
    price: new Map([
      [Province.Quebec, 129],
      [Province.Ontario, 163],
    ]),
  },
  {
    length: 55.1,
    bcVariantId: "gid://shopify/ProductVariant/55237141627249",
    grVariantId: "gid://shopify/ProductVariant/44316444164281",
    rfVariantId: "gid://shopify/ProductVariant/46272744194212",
    price: new Map([
      [Province.Quebec, 136],
      [Province.Ontario, 165],
    ]),
  },
  {
    length: 57.7,
    bcVariantId: "gid://shopify/ProductVariant/55237141660017",
    grVariantId: "gid://shopify/ProductVariant/44316444197049",
    rfVariantId: "gid://shopify/ProductVariant/46272744226980",
    price: new Map([
      [Province.Quebec, 139],
      [Province.Ontario, 167],
    ]),
  },
  {
    length: 59.1,
    bcVariantId: "gid://shopify/ProductVariant/55237141692785",
    grVariantId: "gid://shopify/ProductVariant/44316444229817",
    rfVariantId: "gid://shopify/ProductVariant/46272744259748",
    price: new Map([
      [Province.Quebec, 146],
      [Province.Ontario, 170],
    ]),
  },
  {
    length: 61,
    bcVariantId: "gid://shopify/ProductVariant/55237141725553",
    grVariantId: "gid://shopify/ProductVariant/44316444262585",
    rfVariantId: "gid://shopify/ProductVariant/46272744292516",
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 180],
    ]),
  },
  {
    length: 63,
    bcVariantId: "gid://shopify/ProductVariant/55237141758321",
    grVariantId: "gid://shopify/ProductVariant/44316444295353",
    rfVariantId: "gid://shopify/ProductVariant/46272744325284",
    price: new Map([
      [Province.Quebec, 156],
      [Province.Ontario, 200],
    ]),
  },
  {
    length: 65,
    bcVariantId: "gid://shopify/ProductVariant/55237141791089",
    grVariantId: "gid://shopify/ProductVariant/44316444328121",
    rfVariantId: "gid://shopify/ProductVariant/46272744358052",
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 215],
    ]),
  },
  {
    length: 66.9,
    bcVariantId: "gid://shopify/ProductVariant/55237141823857",
    grVariantId: "gid://shopify/ProductVariant/44316444360889",
    rfVariantId: "gid://shopify/ProductVariant/46272744390820",
    price: new Map([
      [Province.Quebec, 169],
      [Province.Ontario, 225],
    ]),
  },
  {
    length: 68.9,
    bcVariantId: "gid://shopify/ProductVariant/55237141856625",
    grVariantId: "gid://shopify/ProductVariant/44316444393657",
    rfVariantId: "gid://shopify/ProductVariant/46272744423588",
    price: new Map([
      [Province.Quebec, 174],
      [Province.Ontario, 245],
    ]),
  },
  {
    length: 70.9,
    bcVariantId: "gid://shopify/ProductVariant/55237141889393",
    grVariantId: "gid://shopify/ProductVariant/44316444426425",
    rfVariantId: "gid://shopify/ProductVariant/46272744456356",
    price: new Map([
      [Province.Quebec, 176],
      [Province.Ontario, 275],
    ]),
  },
  {
    length: 72.8,
    bcVariantId: "gid://shopify/ProductVariant/55237141922161",
    grVariantId: "gid://shopify/ProductVariant/44316444459193",
    rfVariantId: "gid://shopify/ProductVariant/46272744489124",
    price: new Map([
      [Province.Quebec, 179],
      [Province.Ontario, 285],
    ]),
  },
];

export const glassList48H: Pannel[] = [
  {
    length: 7.9,
    bcVariantId: "gid://shopify/ProductVariant/55237142446449",
    grVariantId: "gid://shopify/ProductVariant/44316444688569",
    rfVariantId: "gid://shopify/ProductVariant/46272744947876",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 75],
    ]),
  },
  {
    length: 8.9,
    bcVariantId: "gid://shopify/ProductVariant/55237142479217",
    grVariantId: "gid://shopify/ProductVariant/44316444721337",
    rfVariantId: "gid://shopify/ProductVariant/46272744980644",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 76],
    ]),
  },
  {
    length: 9.8,
    bcVariantId: "gid://shopify/ProductVariant/55237142511985",
    grVariantId: "gid://shopify/ProductVariant/44316444754105",
    rfVariantId: "gid://shopify/ProductVariant/46272745013412",
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 77],
    ]),
  },
  {
    length: 10.9,
    bcVariantId: "gid://shopify/ProductVariant/55237142544753",
    grVariantId: "gid://shopify/ProductVariant/44316444786873",
    rfVariantId: "gid://shopify/ProductVariant/46272745046180",
    price: new Map([
      [Province.Quebec, 37],
      [Province.Ontario, 80],
    ]),
  },
  {
    length: 11.8,
    bcVariantId: "gid://shopify/ProductVariant/55237142577521",
    grVariantId: "gid://shopify/ProductVariant/44316444819641",
    rfVariantId: "gid://shopify/ProductVariant/46272745078948",
    price: new Map([
      [Province.Quebec, 38],
      [Province.Ontario, 83],
    ]),
  },
  {
    length: 13.8,
    bcVariantId: "gid://shopify/ProductVariant/55237142610289",
    grVariantId: "gid://shopify/ProductVariant/44316444852409",
    rfVariantId: "gid://shopify/ProductVariant/46272745111716",
    price: new Map([
      [Province.Quebec, 39],
      [Province.Ontario, 85],
    ]),
  },
  {
    length: 15.7,
    bcVariantId: "gid://shopify/ProductVariant/55237142643057",
    grVariantId: "gid://shopify/ProductVariant/44316444885177",
    rfVariantId: "gid://shopify/ProductVariant/46272745144484",
    price: new Map([
      [Province.Quebec, 48],
      [Province.Ontario, 87],
    ]),
  },
  {
    length: 17.7,
    bcVariantId: "gid://shopify/ProductVariant/55237142675825",
    grVariantId: "gid://shopify/ProductVariant/44316444917945",
    rfVariantId: "gid://shopify/ProductVariant/46272745177252",
    price: new Map([
      [Province.Quebec, 49],
      [Province.Ontario, 92],
    ]),
  },
  {
    length: 19.7,
    bcVariantId: "gid://shopify/ProductVariant/55237142708593",
    grVariantId: "gid://shopify/ProductVariant/44316444950713",
    rfVariantId: "gid://shopify/ProductVariant/46272745210020",
    price: new Map([
      [Province.Quebec, 59],
      [Province.Ontario, 95],
    ]),
  },
  {
    length: 21.7,
    bcVariantId: "gid://shopify/ProductVariant/55237142741361",
    grVariantId: "gid://shopify/ProductVariant/44316444983481",
    rfVariantId: "gid://shopify/ProductVariant/46272745242788",
    price: new Map([
      [Province.Quebec, 65],
      [Province.Ontario, 100],
    ]),
  },
  {
    length: 23.6,
    bcVariantId: "gid://shopify/ProductVariant/55237142774129",
    grVariantId: "gid://shopify/ProductVariant/44316445016249",
    rfVariantId: "gid://shopify/ProductVariant/46272745275556",
    price: new Map([
      [Province.Quebec, 69],
      [Province.Ontario, 105],
    ]),
  },
  {
    length: 25.6,
    bcVariantId: "gid://shopify/ProductVariant/55237142806897",
    grVariantId: "gid://shopify/ProductVariant/44316445049017",
    rfVariantId: "gid://shopify/ProductVariant/46272745308324",
    price: new Map([
      [Province.Quebec, 76],
      [Province.Ontario, 110],
    ]),
  },
  {
    length: 27.6,
    bcVariantId: "gid://shopify/ProductVariant/55237142839665",
    grVariantId: "gid://shopify/ProductVariant/44316445081785",
    rfVariantId: "gid://shopify/ProductVariant/46272745341092",
    price: new Map([
      [Province.Quebec, 78],
      [Province.Ontario, 112],
    ]),
  },
  {
    length: 29.5,
    bcVariantId: "gid://shopify/ProductVariant/55237142872433",
    grVariantId: "gid://shopify/ProductVariant/44316445114553",
    rfVariantId: "gid://shopify/ProductVariant/46272745373860",
    price: new Map([
      [Province.Quebec, 79],
      [Province.Ontario, 115],
    ]),
  },
  {
    length: 31.5,
    bcVariantId: "gid://shopify/ProductVariant/55237142905201",
    grVariantId: "gid://shopify/ProductVariant/44316445147321",
    rfVariantId: "gid://shopify/ProductVariant/46272745406628",
    price: new Map([
      [Province.Quebec, 89],
      [Province.Ontario, 120],
    ]),
  },
  {
    length: 33.5,
    bcVariantId: "gid://shopify/ProductVariant/55237142937969",
    grVariantId: "gid://shopify/ProductVariant/44316445180089",
    rfVariantId: "gid://shopify/ProductVariant/46272745439396",
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 125],
    ]),
  },
  {
    length: 35.4,
    bcVariantId: "gid://shopify/ProductVariant/55237142970737",
    grVariantId: "gid://shopify/ProductVariant/44316445212857",
    rfVariantId: "gid://shopify/ProductVariant/46272745472164",
    price: new Map([
      [Province.Quebec, 99],
      [Province.Ontario, 135],
    ]),
  },
  {
    length: 37.4,
    bcVariantId: "gid://shopify/ProductVariant/55237143003505",
    grVariantId: "gid://shopify/ProductVariant/44316445245625",
    rfVariantId: "gid://shopify/ProductVariant/46272745504932",
    price: new Map([
      [Province.Quebec, 108],
      [Province.Ontario, 145],
    ]),
  },
  {
    length: 39.4,
    bcVariantId: "gid://shopify/ProductVariant/55237143036273",
    grVariantId: "gid://shopify/ProductVariant/44316445278393",
    rfVariantId: "gid://shopify/ProductVariant/46272745537700",
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 150],
    ]),
  },
  {
    length: 41.3,
    bcVariantId: "gid://shopify/ProductVariant/55237143069041",
    grVariantId: "gid://shopify/ProductVariant/44316445311161",
    rfVariantId: "gid://shopify/ProductVariant/46272745570468",
    price: new Map([
      [Province.Quebec, 118],
      [Province.Ontario, 155],
    ]),
  },
  {
    length: 43.3,
    bcVariantId: "gid://shopify/ProductVariant/55237143101809",
    grVariantId: "gid://shopify/ProductVariant/44316445343929",
    rfVariantId: "gid://shopify/ProductVariant/46272745603236",
    price: new Map([
      [Province.Quebec, 119],
      [Province.Ontario, 160],
    ]),
  },
  {
    length: 45.3,
    bcVariantId: "gid://shopify/ProductVariant/55237143134577",
    grVariantId: "gid://shopify/ProductVariant/44316445376697",
    rfVariantId: "gid://shopify/ProductVariant/46272745636004",
    price: new Map([
      [Province.Quebec, 128],
      [Province.Ontario, 165],
    ]),
  },
  {
    length: 47.2,
    bcVariantId: "gid://shopify/ProductVariant/55237143167345",
    grVariantId: "gid://shopify/ProductVariant/44316445409465",
    rfVariantId: "gid://shopify/ProductVariant/46272745668772",
    price: new Map([
      [Province.Quebec, 129],
      [Province.Ontario, 170],
    ]),
  },
  {
    length: 49.2,
    bcVariantId: "gid://shopify/ProductVariant/55237143200113",
    grVariantId: "gid://shopify/ProductVariant/44316445442233",
    rfVariantId: "gid://shopify/ProductVariant/46272745701540",
    price: new Map([
      [Province.Quebec, 139],
      [Province.Ontario, 175],
    ]),
  },
  {
    length: 51.2,
    bcVariantId: "gid://shopify/ProductVariant/55237143232881",
    grVariantId: "gid://shopify/ProductVariant/44316445475001",
    rfVariantId: "gid://shopify/ProductVariant/46272745734308",
    price: new Map([
      [Province.Quebec, 146],
      [Province.Ontario, 180],
    ]),
  },
  {
    length: 53.1,
    bcVariantId: "gid://shopify/ProductVariant/55237143265649",
    grVariantId: "gid://shopify/ProductVariant/44316445507769",
    rfVariantId: "gid://shopify/ProductVariant/46272745767076",
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 185],
    ]),
  },
  {
    length: 55.1,
    bcVariantId: "gid://shopify/ProductVariant/55237143298417",
    grVariantId: "gid://shopify/ProductVariant/44316445540537",
    rfVariantId: "gid://shopify/ProductVariant/46272745799844",
    price: new Map([
      [Province.Quebec, 156],
      [Province.Ontario, 190],
    ]),
  },
  {
    length: 57.7,
    bcVariantId: "gid://shopify/ProductVariant/55237143331185",
    grVariantId: "gid://shopify/ProductVariant/44316445573305",
    rfVariantId: "gid://shopify/ProductVariant/46272745832612",
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 195],
    ]),
  },
  {
    length: 59.1,
    bcVariantId: "gid://shopify/ProductVariant/55237143363953",
    grVariantId: "gid://shopify/ProductVariant/44316445606073",
    rfVariantId: "gid://shopify/ProductVariant/46272745865380",
    price: new Map([
      [Province.Quebec, 165],
      [Province.Ontario, 200],
    ]),
  },
  {
    length: 61,
    bcVariantId: "gid://shopify/ProductVariant/55237143396721",
    grVariantId: "gid://shopify/ProductVariant/44316445638841",
    rfVariantId: "gid://shopify/ProductVariant/46272745898148",
    price: new Map([
      [Province.Quebec, 169],
      [Province.Ontario, 205],
    ]),
  },
  {
    length: 63,
    bcVariantId: "gid://shopify/ProductVariant/55237143429489",
    grVariantId: "gid://shopify/ProductVariant/44316445671609",
    rfVariantId: "gid://shopify/ProductVariant/46272745930916",
    price: new Map([
      [Province.Quebec, 179],
      [Province.Ontario, 215],
    ]),
  },
  {
    length: 65,
    bcVariantId: "gid://shopify/ProductVariant/55237143462257",
    grVariantId: "gid://shopify/ProductVariant/44316445704377",
    rfVariantId: "gid://shopify/ProductVariant/46272745963684",
    price: new Map([
      [Province.Quebec, 187],
      [Province.Ontario, 220],
    ]),
  },
  {
    length: 66.9,
    bcVariantId: "gid://shopify/ProductVariant/55237143495025",
    grVariantId: "gid://shopify/ProductVariant/44316445737145",
    rfVariantId: "gid://shopify/ProductVariant/46272745996452",
    price: new Map([
      [Province.Quebec, 189],
      [Province.Ontario, 230],
    ]),
  },
  {
    length: 68.9,
    bcVariantId: "gid://shopify/ProductVariant/55237143527793",
    grVariantId: "gid://shopify/ProductVariant/44316445769913",
    rfVariantId: "gid://shopify/ProductVariant/46272746029220",
    price: new Map([
      [Province.Quebec, 198],
      [Province.Ontario, 260],
    ]),
  },
  {
    length: 70.9,
    bcVariantId: "gid://shopify/ProductVariant/55237143560561",
    grVariantId: "gid://shopify/ProductVariant/44316445802681",
    rfVariantId: "gid://shopify/ProductVariant/46272746061988",
    price: new Map([
      [Province.Quebec, 208],
      [Province.Ontario, 280],
    ]),
  },
  {
    length: 72.8,
    bcVariantId: "gid://shopify/ProductVariant/55237143593329",
    grVariantId: "gid://shopify/ProductVariant/44316445835449",
    rfVariantId: "gid://shopify/ProductVariant/46272746094756",
    price: new Map([
      [Province.Quebec, 209.0],
      [Province.Ontario, 299],
    ]),
  },
];

// R pannels:
export const glassList48R: Pannel[] = [
  {
    length: 9.8,
    bcVariantId: "gid://shopify/ProductVariant/55237143658865",
    grVariantId: "gid://shopify/ProductVariant/44790328590521",
    price: new Map([
      [Province.Quebec, 94],
      [Province.Ontario, 113],
    ]),
    isRPannel: true,
  },
  {
    length: 10.9,
    rfVariantId: "gid://shopify/ProductVariant/50443947901092",
    price: new Map([
      [Province.Quebec, 95],
      [Province.Ontario, 114],
    ]),
    isRPannel: true,
  },
  {
    length: 11.8,
    bcVariantId: "gid://shopify/ProductVariant/55237143691633",
    grVariantId: "gid://shopify/ProductVariant/44790328656057",
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 115],
    ]),
    isRPannel: true,
  },
  {
    length: 13.8,
    bcVariantId: "gid://shopify/ProductVariant/55237143724401",
    grVariantId: "gid://shopify/ProductVariant/44790328721593",
    rfVariantId: "gid://shopify/ProductVariant/50443947966628",
    price: new Map([
      [Province.Quebec, 98],
      [Province.Ontario, 120],
    ]),
    isRPannel: true,
  },
  {
    length: 15.7,
    bcVariantId: "gid://shopify/ProductVariant/55237143757169",
    grVariantId: "gid://shopify/ProductVariant/44790328787129",
    rfVariantId: "gid://shopify/ProductVariant/50443948032164",
    price: new Map([
      [Province.Quebec, 106],
      [Province.Ontario, 130],
    ]),
    isRPannel: true,
  },
  {
    length: 17.7,
    bcVariantId: "gid://shopify/ProductVariant/55237143789937",
    grVariantId: "gid://shopify/ProductVariant/44790328852665",
    rfVariantId: "gid://shopify/ProductVariant/50443948097700",
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 135],
    ]),
    isRPannel: true,
  },
  {
    length: 19.7,
    bcVariantId: "gid://shopify/ProductVariant/55237143822705",
    grVariantId: "gid://shopify/ProductVariant/44790328918201",
    rfVariantId: "gid://shopify/ProductVariant/50443948163236",
    price: new Map([
      [Province.Quebec, 113],
      [Province.Ontario, 140],
    ]),
    isRPannel: true,
  },
  {
    length: 21.7,
    bcVariantId: "gid://shopify/ProductVariant/55237143855473",
    grVariantId: "gid://shopify/ProductVariant/44790328983737",
    rfVariantId: "gid://shopify/ProductVariant/50443948228772",
    price: new Map([
      [Province.Quebec, 127],
      [Province.Ontario, 145],
    ]),
    isRPannel: true,
  },
  {
    length: 23.6,
    bcVariantId: "gid://shopify/ProductVariant/55237143888241",
    grVariantId: "gid://shopify/ProductVariant/44790329049273",
    rfVariantId: "gid://shopify/ProductVariant/50443948294308",
    price: new Map([
      [Province.Quebec, 131],
      [Province.Ontario, 150],
    ]),
    isRPannel: true,
  },
  {
    length: 25.6,
    bcVariantId: "gid://shopify/ProductVariant/55237143921009",
    grVariantId: "gid://shopify/ProductVariant/44790329114809",
    rfVariantId: "gid://shopify/ProductVariant/50443948359844",
    price: new Map([
      [Province.Quebec, 135],
      [Province.Ontario, 155],
    ]),
    isRPannel: true,
  },
  {
    length: 27.6,
    bcVariantId: "gid://shopify/ProductVariant/55237143953777",
    grVariantId: "gid://shopify/ProductVariant/44790329180345",
    rfVariantId: "gid://shopify/ProductVariant/50443948425380",
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 157],
    ]),
    isRPannel: true,
  },
  {
    length: 29.5,
    bcVariantId: "gid://shopify/ProductVariant/55237143986545",
    grVariantId: "gid://shopify/ProductVariant/44790329245881",
    rfVariantId: "gid://shopify/ProductVariant/50443948490916",
    price: new Map([
      [Province.Quebec, 155],
      [Province.Ontario, 159],
    ]),
    isRPannel: true,
  },
  {
    length: 31.5,
    bcVariantId: "gid://shopify/ProductVariant/55237144019313",
    grVariantId: "gid://shopify/ProductVariant/44790329311417",
    rfVariantId: "gid://shopify/ProductVariant/50443948556452",
    price: new Map([
      [Province.Quebec, 157],
      [Province.Ontario, 161],
    ]),
    isRPannel: true,
  },
  {
    length: 33.5,
    bcVariantId: "gid://shopify/ProductVariant/55237144052081",
    grVariantId: "gid://shopify/ProductVariant/44790329376953",
    rfVariantId: "gid://shopify/ProductVariant/50443948621988",
    price: new Map([
      [Province.Quebec, 162],
      [Province.Ontario, 162],
    ]),
    isRPannel: true,
  },
  {
    length: 35.4,
    bcVariantId: "gid://shopify/ProductVariant/55237144084849",
    grVariantId: "gid://shopify/ProductVariant/44790329442489",
    rfVariantId: "gid://shopify/ProductVariant/50443948687524",
    price: new Map([
      [Province.Quebec, 165],
      [Province.Ontario, 165],
    ]),
    isRPannel: true,
  },
  {
    length: 37.4,
    bcVariantId: "gid://shopify/ProductVariant/55237144117617",
    grVariantId: "gid://shopify/ProductVariant/44790329508025",
    rfVariantId: "gid://shopify/ProductVariant/50443948753060",
    price: new Map([
      [Province.Quebec, 171],
      [Province.Ontario, 171],
    ]),
    isRPannel: true,
  },
  {
    length: 39.4,
    bcVariantId: "gid://shopify/ProductVariant/55237144150385",
    grVariantId: "gid://shopify/ProductVariant/44790329573561",
    rfVariantId: "gid://shopify/ProductVariant/50443948818596",
    price: new Map([
      [Province.Quebec, 174],
      [Province.Ontario, 174],
    ]),
    isRPannel: true,
  },
  {
    length: 41.3,
    bcVariantId: "gid://shopify/ProductVariant/55237144183153",
    grVariantId: "gid://shopify/ProductVariant/44790329639097",
    rfVariantId: "gid://shopify/ProductVariant/50443948884132",
    price: new Map([
      [Province.Quebec, 180],
      [Province.Ontario, 180],
    ]),
    isRPannel: true,
  },
  {
    length: 43.3,
    bcVariantId: "gid://shopify/ProductVariant/55237144215921",
    grVariantId: "gid://shopify/ProductVariant/44790329704633",
    rfVariantId: "gid://shopify/ProductVariant/50443948949668",
    price: new Map([
      [Province.Quebec, 184],
      [Province.Ontario, 184],
    ]),
    isRPannel: true,
  },
  {
    length: 45.3,
    bcVariantId: "gid://shopify/ProductVariant/55237144248689",
    grVariantId: "gid://shopify/ProductVariant/44790329770169",
    rfVariantId: "gid://shopify/ProductVariant/50443949015204",
    price: new Map([
      [Province.Quebec, 189],
      [Province.Ontario, 189],
    ]),
    isRPannel: true,
  },
  {
    length: 47.2,
    bcVariantId: "gid://shopify/ProductVariant/55237144281457",
    grVariantId: "gid://shopify/ProductVariant/44790329835705",
    rfVariantId: "gid://shopify/ProductVariant/50443949080740",
    price: new Map([
      [Province.Quebec, 192],
      [Province.Ontario, 192],
    ]),
    isRPannel: true,
  },
  {
    length: 49.2,
    bcVariantId: "gid://shopify/ProductVariant/55237144314225",
    grVariantId: "gid://shopify/ProductVariant/44790329901241",
    rfVariantId: "gid://shopify/ProductVariant/50443949146276",
    price: new Map([
      [Province.Quebec, 196],
      [Province.Ontario, 196],
    ]),
    isRPannel: true,
  },
  {
    length: 51.2,
    bcVariantId: "gid://shopify/ProductVariant/55237144346993",
    grVariantId: "gid://shopify/ProductVariant/44790329966777",
    rfVariantId: "gid://shopify/ProductVariant/50443949211812",
    price: new Map([
      [Province.Quebec, 200],
      [Province.Ontario, 200],
    ]),
    isRPannel: true,
  },
  {
    length: 53.1,
    bcVariantId: "gid://shopify/ProductVariant/55237144379761",
    grVariantId: "gid://shopify/ProductVariant/44790330032313",
    rfVariantId: "gid://shopify/ProductVariant/50443949277348",
    price: new Map([
      [Province.Quebec, 202],
      [Province.Ontario, 202],
    ]),
    isRPannel: true,
  },
  {
    length: 55.1,
    bcVariantId: "gid://shopify/ProductVariant/55237144412529",
    grVariantId: "gid://shopify/ProductVariant/44790330097849",
    rfVariantId: "gid://shopify/ProductVariant/50443949342884",
    price: new Map([
      [Province.Quebec, 206],
      [Province.Ontario, 206],
    ]),
    isRPannel: true,
  },
  {
    length: 57.7,
    bcVariantId: "gid://shopify/ProductVariant/55237144445297",
    grVariantId: "gid://shopify/ProductVariant/44790330163385",
    rfVariantId: "gid://shopify/ProductVariant/50443949408420",
    price: new Map([
      [Province.Quebec, 211],
      [Province.Ontario, 211],
    ]),
    isRPannel: true,
  },
  {
    length: 59.1,
    bcVariantId: "gid://shopify/ProductVariant/55237144478065",
    grVariantId: "gid://shopify/ProductVariant/44790330228921",
    rfVariantId: "gid://shopify/ProductVariant/50443949473956",
    price: new Map([
      [Province.Quebec, 216],
      [Province.Ontario, 216],
    ]),
    isRPannel: true,
  },
  {
    length: 61,
    bcVariantId: "gid://shopify/ProductVariant/55237144510833",
    grVariantId: "gid://shopify/ProductVariant/44790330294457",
    rfVariantId: "gid://shopify/ProductVariant/50443949539492",
    price: new Map([
      [Province.Quebec, 218],
      [Province.Ontario, 218],
    ]),
    isRPannel: true,
  },
  {
    length: 63,
    bcVariantId: "gid://shopify/ProductVariant/55237144543601",
    grVariantId: "gid://shopify/ProductVariant/44790330359993",
    rfVariantId: "gid://shopify/ProductVariant/50443949605028",
    price: new Map([
      [Province.Quebec, 222],
      [Province.Ontario, 222],
    ]),
    isRPannel: true,
  },
  {
    length: 65,
    bcVariantId: "gid://shopify/ProductVariant/55237144576369",
    grVariantId: "gid://shopify/ProductVariant/44790330425529",
    rfVariantId: "gid://shopify/ProductVariant/50443949670564",
    price: new Map([
      [Province.Quebec, 227],
      [Province.Ontario, 227],
    ]),
    isRPannel: true,
  },
  {
    length: 66.9,
    bcVariantId: "gid://shopify/ProductVariant/55237144609137",
    grVariantId: "gid://shopify/ProductVariant/44790330491065",
    rfVariantId: "gid://shopify/ProductVariant/50443949736100",
    price: new Map([
      [Province.Quebec, 231],
      [Province.Ontario, 231],
    ]),
    isRPannel: true,
  },
  {
    length: 68.9,
    bcVariantId: "gid://shopify/ProductVariant/55237144641905",
    grVariantId: "gid://shopify/ProductVariant/44790330556601",
    rfVariantId: "gid://shopify/ProductVariant/50443949801636",
    price: new Map([
      [Province.Quebec, 236],
      [Province.Ontario, 236],
    ]),
    isRPannel: true,
  },
];

export const glassListOtherR: Pannel[] = [
  {
    length: 35.4,
    bcVariantId: "gid://shopify/ProductVariant/55237144674673",
    grVariantId: "gid://shopify/ProductVariant/44359285309625",
    rfVariantId: "gid://shopify/ProductVariant/50443948654756",
    price: new Map([
      [Province.Quebec, 150],
      [Province.Ontario, 180],
    ]),
    isRPannel: true,
  },
];

export const doorCost = new Map([
  [Province.Quebec, 160],
  [Province.Ontario, 180],
]);

export const DOOR_WIDTH = 36;
